import { render } from "./TermsOfUse.vue?vue&type=template&id=3783b0fc&scoped=true"
const script = {}

import "./TermsOfUse.vue?vue&type=style&index=0&id=3783b0fc&lang=css"
import "./TermsOfUse.vue?vue&type=style&index=1&id=3783b0fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3783b0fc"]])

export default __exports__